import CategoriesBar from "../../../globalcomponents/navbar/categorieslist/CategoriesBar";
import NavbarTwo from "../../../globalcomponents/navbar/NavbarTwo";
import Pagenation from "../../../globalcomponents/pagenation/Pagenation";
import BrowsingHistory from "../../ProductsCards/BrowsingHistory";
import FrequentlyBrought from "../../ProductsCards/FrequentlyBrought";
import RelatedProducts from "../../ProductsCards/RelatedProducts";
import RelevantProducts from "../../ProductsCards/RelevantProducts";
import OrderItems from "./OrderItems";

const Orders = () => {
  return (
    <>
      <div className=" display-max">
        <NavbarTwo />
        <CategoriesBar />
        <div className=" container mx-auto w-70 mt-3">
          <div className=" d-flex justify-content-between align-items-center">
            <div>
              <h3>Your Orders</h3>
            </div>
            <div className="w-40">
              <div className=" input-group-text input-group input-group-outline input-group-lg ms-0 w-97">
                <input
                  type="text"
                  className="form-control fw-bold text-black"
                  placeholder="Search for 'Orders"
                  name=""
                  id=""
                />
                <span className="input-group-text me-0 input-search-icon z-index-1">
                  <i className="bi bi-search text-black fs-7 me-2"></i>
                </span>
              </div>
            </div>
          </div>
          <OrderItems />
          <Pagenation
            currentPage={1}
            totalPages={10}
            onPageChange={(page) => {}}
          />
        </div>
        <div className=" container">
          <div className=" mt-4 mb-5 px-3">
            <h5 className=" fw-bolder">
              Relevant items customers are likely to buy
            </h5>
            <RelevantProducts />
          </div>
          <div className=" mt-4 mb-5 px-3">
            <h5 className=" fw-bolder">Related items bought by customers</h5>
            <RelatedProducts />
          </div>
          <div className=" mt-4 mb-5 px-3">
            <h5 className=" fw-bolder">
              Customers who bought this item also bought
            </h5>
            <FrequentlyBrought />
          </div>
          <div className=" mt-4 mb-5 px-3">
            <h5 className=" fw-bolder">Inspired by your browsing history</h5>
            <BrowsingHistory />
          </div>
        </div>
      </div>
    </>
  );
};

export default Orders;
